import { dbPromise } from "./db";

export async function addToQueue(data) {
    const db = await dbPromise

    await db.add("queue", {
        ...data,
        createdAt: new Date().toISOString()
    })
}

// For performance_update: replace any existing queue item for the same URL
// so repeated offline edits/deletes on the same attendance don't stack up.
export async function upsertPerformanceQueue(data) {
    const db = await dbPromise
    const url = data.payload?._url

    if (url) {
        const all = await db.getAll("queue")
        const existing = all.find(item =>
            item.type === "performance_update" && item.payload?._url === url
        )
        if (existing) {
            await db.delete("queue", existing.id)
        }
    }

    await db.add("queue", {
        ...data,
        createdAt: new Date().toISOString()
    })
}

export async function getAllQueue() {
    const db = await dbPromise
    return db.getAll("queue")
}

export async function removeFromQueue(id) {
    const db = await dbPromise
    return db.delete("queue", id)
}

function getCurrentUserId() {
    return document.querySelector('meta[name="current-user-id"]')?.content || "unknown"
}

export async function saveLog(message) {
    const db = await dbPromise
    const today = new Date().toISOString().slice(0, 10)
    await db.add("logs", {
        message,
        date: today,
        userId: getCurrentUserId()
    })
}

export async function getLogsToday() {
    const db = await dbPromise
    const today = new Date().toISOString().slice(0, 10)
    const userId = getCurrentUserId()
    const all = await db.getAll("logs")
    return all.filter(log => log.date === today && log.userId === userId)
}

export async function purgeOldLogs() {
    const db = await dbPromise
    const today = new Date().toISOString().slice(0, 10)
    const all = await db.getAll("logs")
    const old = all.filter(log => log.date !== today)
    return Promise.all(old.map(log => db.delete("logs", log.id)))
}

export async function saveAttendanceStatus(status) {
    const db = await dbPromise

    await db.put("attendance_status", {
        key: "current",
        showed_up_at: status.showed_up_at,
        left_at: status.left_at,
        date: status.date,
        saveAt: new Date().toISOString()
    })
}

export async function getAttendanceStatus() {
    const db = await dbPromise
    try {
        return await db.get("attendance_status", "current")
    } catch {
        return null
    }
}

export async function clearAttendanceStatus() {
    const db = await dbPromise
    try {
        await db.delete("attendance_status", "current")
    } catch {}
}